import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { marketplaceBalanceResponse } from './MarketplaceBalance.js';

export const marketplaceBalanceTransformSchema = marketplaceBalanceResponse.transform((result) => ({ data: result }));

export const marketplaceBalanceApiResponse = {
  parse: (data: unknown) => z.union([marketplaceBalanceTransformSchema, apiErrorSchema]).parse(data),
} as const;
